import { useState } from "react";
import { ChevronRight, Crown, Pencil, Phone, Search, Star, Trash2 } from "lucide-react";
import { money, calcCommission, effectiveRate } from "../lib/finance";
import { PageTitle, Empty } from "./common";
import { computeCustomerLtv } from "./VipCustomersCard";
import { CustomerCard } from "./CustomerCard";

export function Customers({ onQuotesSent, customers, policies, quotes = [], vehicles = [], onVehicleSaved, onCustomerUpdated, branches, settings, query, setQuery, setModal, setSelectedCustomer, remove, setEditingCustomer, setEditingPolicy, setEditingQuote, onNewPolicyFor, onNewQuoteFor, onToggleFavorite, onOpenPortal, can = () => true }) {
  const [openId, setOpenId] = useState(null);
  const q = query.toLocaleLowerCase("tr");
  const filtered = customers.filter((c) => `${c.name} ${c.phone} ${c.email} ${c.city || ""} ${c.district || ""}`.toLocaleLowerCase("tr").includes(q));
  const openEdit = (c) => { setEditingCustomer(c); setModal("customer"); };
  const openNew = () => { setEditingCustomer(null); setModal("customer"); };
  const open = customers.find((c) => c.id === openId);
  if (open) {
    return (
      <CustomerCard onQuotesSent={onQuotesSent} customer={open} policies={policies} quotes={quotes} vehicles={vehicles} onVehicleSaved={onVehicleSaved} onCustomerUpdated={onCustomerUpdated} branches={branches} settings={settings}
        onBack={() => setOpenId(null)} onEdit={() => openEdit(open)}
        onNewPolicy={() => onNewPolicyFor(open)} onNewQuote={() => onNewQuoteFor(open)}
        onOpenPolicy={(p) => { setEditingPolicy(p); setModal("policy"); }} onOpenQuote={(x) => { setEditingQuote(x); setModal("quote"); }}
        onToggleFavorite={onToggleFavorite} onOpenPortal={onOpenPortal}
        onDelete={can("canDeleteRecords") ? () => remove("customer", open.id) : null} />
    );
  }
  const statsOf = (c) => {
    const pols = policies.filter((p) => p.customer === c.name);
    const personal = pols.reduce((s, p) => s + calcCommission(p.premium, effectiveRate(p, branches), settings.netDivisor, settings.personalShare, p.netPremium, p.status === "iptal" ? p.cancellationRefund : null).personal, 0);
    const quoteCount = quotes.filter((x) => x.customerId === c.id || (!x.customerId && x.customerName === c.name)).length;
    return { count: pols.length, personal, quoteCount };
  };
  return (
    <>
      <PageTitle eyebrow="MÜŞTERİ PORTFÖYÜ" title="Müşteriler" description="Müşteriye tıklayarak kartını açın: teklif, poliçe ve belge arşivi tek yerde." action="Yeni müşteri" onAction={openNew} />
      <div className="toolbar">
        <div className="inline-search"><Search size={16} /><input data-testid="customer-search-input" value={query} onChange={(e) => setQuery(e.target.value)} placeholder="Müşteri, telefon veya il ara..." /></div>
        <span className="ctl-count">{filtered.length} müşteri</span>
      </div>
      <div className="crows panel" data-testid="customer-list">
        {filtered.map((c) => {
          const st = statsOf(c);
          const initials = c.name.split(" ").map((x) => x[0]).join("").slice(0, 2);
          return (
            <div className="crow" key={c.id} data-testid={`customer-card-${c.id}`} onClick={() => setOpenId(c.id)} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter") setOpenId(c.id); }}>
              <div className="avatar">{initials}</div>
              <div className="cr-main">
                <strong data-testid={`customer-detail-${c.id}`}>{c.name}<VipBadge customer={c} policies={policies} branches={branches} settings={settings} />{c.favorite && <Star size={12} fill="#f59e0b" color="#f59e0b" />}</strong>
                <span>{c.type}{c.phone ? ` · ${c.phone}` : ""}{c.city ? ` · ${[c.district, c.city].filter(Boolean).join(" / ")}` : ""}</span>
              </div>
              <div className="cr-stat"><b>{st.count}</b><small>poliçe</small></div>
              <div className="cr-stat"><b>{st.quoteCount}</b><small>teklif</small></div>
              <div className="cr-stat wide"><b>{money(st.personal)}</b><small>hak ediş</small></div>
              <div className="cr-actions" onClick={(e) => e.stopPropagation()}>
                {c.phone && <a className="row-action" href={`tel:${c.phone}`} title="Ara" data-testid={`customer-call-${c.id}`}><Phone size={15} /></a>}
                <button className="row-action" title="Düzenle" data-testid={`edit-customer-${c.id}`} onClick={() => openEdit(c)}><Pencil size={15} /></button>
                {can("canDeleteRecords") && <button className="row-action" title="Sil" data-testid={`delete-customer-${c.id}`} onClick={() => remove("customer", c.id)}><Trash2 size={15} /></button>}
              </div>
              <ChevronRight size={16} className="cr-chevron" />
            </div>
          );
        })}
        {!filtered.length && <Empty text="Müşteri bulunamadı" />}
      </div>
    </>
  );
}


export function VipBadge({ customer, policies, branches, settings, threshold = 5000 }) {
  const { ltv } = computeCustomerLtv(customer, policies, branches, settings);
  if (ltv < threshold) return null;
  return <span className="vip-badge" title={`VIP · ${money(ltv)}`} data-testid={`vip-badge-${customer.id}`}><Crown size={11} /> VIP</span>;
}

// ---------------- Calendar Export Banner (Renewals page) ----------------
// ---------------- Quote Email Modal ----------------
